import React from 'react';

import { StyledModalDetail } from './style';

import Buttons from '../../../core/Buttons';

export const ModalStation = ({ stationDetail, setShowModalStation }) => (
  <StyledModalDetail
    title={`Información de la emisora ${stationDetail.locality}`}
    clickCloseIcon={() => setShowModalStation(false)}
  >
    {stationDetail ? (
      <div>
        <dl>
          <dt className="title">Frecuencia</dt>
          <dd className="description">
            {stationDetail.frequency ? stationDetail.frequency : `---`}
          </dd>
          <dt className="title">Observaciones</dt>
          <dd className="description">
            {' '}
            {stationDetail.observations ? stationDetail.observations : `---`}
          </dd>
          <dt className="title">Director</dt>
          <dd className="description">
            {' '}
            {stationDetail.directorName
              ? `${stationDetail.directorName} ${
                  stationDetail.directorLastName
                    ? stationDetail.directorLastName
                    : ''
                }`
              : `---`}
          </dd>
          <dt className="title">Teléfono</dt>
          <dd className="description">
            {' '}
            {stationDetail.phoneNumber ? stationDetail.phoneNumber : `---`}
          </dd>
          <dt className="title">Teléfono Corporativo</dt>
          <dd className="description">
            {' '}
            {stationDetail.corporativeNumber
              ? stationDetail.corporativeNumber
              : `---`}
          </dd>
          <dt className="title">Telefono Móvil</dt>
          <dd className="description">
            {' '}
            {stationDetail.mobilePhone ? stationDetail.mobilePhone : `---`}
          </dd>
          <dt className="title">Fax</dt>
          <dd className="description">
            {' '}
            {stationDetail.fax ? stationDetail.fax : `---`}
          </dd>
          <dt className="title">Provincia</dt>
          <dd className="description">
            {' '}
            {stationDetail.autonomousCommunity
              ? stationDetail.autonomousCommunity
              : `---`}
          </dd>
          <dt className="title">Formato</dt>
          <dd className="description">
            {' '}
            {stationDetail.format ? stationDetail.format : `---`}
          </dd>
          <dt className="title">Dirección</dt>
          <dd className="description">
            {' '}
            {stationDetail.address ? stationDetail.address : `---`}{' '}
            {stationDetail.addressNumber ? stationDetail.addressNumber : ``}{' '}
            {stationDetail.addressFloor
              ? `- ${stationDetail.addressFloor}`
              : ``}
          </dd>
          <dt className="title">C.P.</dt>
          <dd className="description">
            {' '}
            {stationDetail.postalCode ? stationDetail.postalCode : `---`}
          </dd>
        </dl>
        <div className="wrapper-button">
          <Buttons onClick={() => setShowModalStation(false)} dark>
            Aceptar
          </Buttons>
        </div>
      </div>
    ) : (
      <p>No se encontrarón detalles de la emisora</p>
    )}
  </StyledModalDetail>
);
